import { createElement, useEffect } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { RsosFavicon } from '@rsos/assets/icons';

// Serialize the RsosFavicon icon to an inline SVG data URI usable as a
// <link rel="icon"> href. SVGLoader wraps the <svg> in a Box, so slice out just
// the <svg>…</svg> for a valid standalone favicon.
const buildRebrandedFavicon = (): string => {
  const markup = renderToStaticMarkup(createElement(RsosFavicon));
  const svg = markup.slice(
    markup.indexOf('<svg'),
    markup.lastIndexOf('</svg>') + '</svg>'.length,
  );
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

// Owns the document favicon for every app that mounts Layout (RSP/CSP/ICSP/Admin/auth).
// The server template no longer renders a favicon link, so create one if it isn't present yet.
const useRebrandedFavicon = () => {
  useEffect(() => {
    let link: HTMLLinkElement | null =
      document.querySelector("link[rel='shortcut icon']") ||
      document.querySelector("link[rel~='icon']");

    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }

    link.setAttribute('href', buildRebrandedFavicon());
  }, []);
};

export default useRebrandedFavicon;
